__turbopack_context__.v({
  "actions": "ZGuqgW_actions",
  "body": "ZGuqgW_body",
  "close": "ZGuqgW_close",
  "closeButton": "ZGuqgW_closeButton",
  "fixRadiomark": "ZGuqgW_fixRadiomark",
  "footer": "ZGuqgW_footer",
  "format": "ZGuqgW_format",
  "formats": "ZGuqgW_formats",
  "header": "ZGuqgW_header",
  "hidden": "ZGuqgW_hidden",
  "modalBody": "ZGuqgW_modalBody",
  "requestButton": "ZGuqgW_requestButton",
});
